export const FETCH_PRICE_BOARD_REQUEST = 'FETCH_PRICE_BOARD_REQUEST';
export const FETCH_PRICE_BOARD_SUCCESS = 'FETCH_PRICE_BOARD_SUCCESS';
export const FETCH_PRICE_BOARD_FAILURE = 'FETCH_PRICE_BOARD_FAILURE';
export const SET_CURRENT_PRICE = 'SET_CURRENT_PRICE';